"use client"
import React from "react";
import Asset from "@/components/shared/Asset";

import "@/components/shared/ActivityLogEntry.css";

const moment = require("moment");

const ActivityLogEntry = ({
  activityLog,
  showName = true,
  showTimestamp = true
}) => {
  return (
    <div
      className="activity-log-entry"
      id={`activity-log-entry-${activityLog.id}`}
    >
      <div className="header">
        {showName && <h5>{activityLog.subObjectTitle}</h5>}
        <div className="flex-grow" />
        {showTimestamp && (
          <span>
            {moment(activityLog.createdDate).format("MMMM Do YYYY, h:mma")}
          </span>
        )}
      </div>
      <div className="content">
        {activityLog.stateChange && activityLog.stateChange.length > 0 && (
          <div className="state-change">
            {activityLog.stateChange.map(change => {
              return (
                <span>
                  Changed <b>{change.fieldName}</b> to{" "}
                  <b>{`${change.fieldValue}`}</b>
                </span>
              );
            })}
          </div>
        )}
        {activityLog.notes && (
          <div className="notes">
            <span>
              <b>Notes</b>
            </span>
            <br />
            <span>{activityLog.notes}</span>
          </div>
        )}
        {activityLog.assets && activityLog.assets.length > 0 && (
          <div className="assets">
            <Asset assets={activityLog.assets} />
          </div>
        )}
      </div>
    </div>
  );
};
export default ActivityLogEntry;
